import React, { lazy } from 'react';

import { useTranslation } from '~/app';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '~/components/Dialog/Dialog';

/**
 * @author      Michael Hettmer <mail@michael-hettmer.de>
 * @copyright   2019 Plusbyte UG (haftungsbeschränkt)
 * @license     {@link https://plusbyte.de Plusbyte License}
 */

interface LoginProps {
  modalOpen: boolean;
  onLoginSuccess: () => void;
  onLoginCancelled: () => void;
  onForgotPassword: () => void;
  onCreateAccount: (email: string, password: string, firebaseIdToken?: string) => void;
}

const LoginFirebaseLazy = lazy(() => import('./LoginFirebase'));

const Login = ({
  modalOpen,
  onLoginSuccess,
  onLoginCancelled,
  onForgotPassword,
  onCreateAccount,
}: LoginProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog open={modalOpen} onOpenChange={(open) => !open && onLoginCancelled()}>
      <DialogContent size="lg" className="sm:max-w-xl">
        <DialogTitle>{t('start_accountLoginDialogTitle')}</DialogTitle>
        <DialogDescription>{t('start_accountLoginDialogDescription')}</DialogDescription>

        <div className="mt-4">
          {typeof window !== 'undefined' && (
            <React.Suspense fallback={<div />}>
              <LoginFirebaseLazy {...{ onLoginSuccess, onForgotPassword, onCreateAccount }} />
            </React.Suspense>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Login;
